import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export function createScopedLineTokens(context, offset) {
  var tokenCount = context.getCount();
  var tokenIndex = context.findTokenIndexAtOffset(offset);
  var desiredLanguageId = context.getLanguageId(tokenIndex);
  var lastTokenIndex = tokenIndex;

  while (lastTokenIndex + 1 < tokenCount && context.getLanguageId(lastTokenIndex + 1) === desiredLanguageId) {
    lastTokenIndex++;
  }

  var firstTokenIndex = tokenIndex;

  while (firstTokenIndex > 0 && context.getLanguageId(firstTokenIndex - 1) === desiredLanguageId) {
    firstTokenIndex--;
  }

  return new ScopedLineTokens(context, desiredLanguageId, firstTokenIndex, lastTokenIndex + 1, context.getStartOffset(firstTokenIndex), context.getEndOffset(lastTokenIndex));
}
export var ScopedLineTokens = /*#__PURE__*/function () {
  function ScopedLineTokens(actual, languageId, firstTokenIndex, lastTokenIndex, firstCharOffset, lastCharOffset) {
    _classCallCheck(this, ScopedLineTokens);

    this._actual = actual;
    this.languageId = languageId;
    this._firstTokenIndex = firstTokenIndex;
    this._lastTokenIndex = lastTokenIndex;
    this.firstCharOffset = firstCharOffset;
    this._lastCharOffset = lastCharOffset;
  }

  _createClass(ScopedLineTokens, [{
    key: "getLineContent",
    value: function getLineContent() {
      var actualLineContent = this._actual.getLineContent();

      return actualLineContent.substring(this.firstCharOffset, this._lastCharOffset);
    }
  }, {
    key: "getActualLineContentBefore",
    value: function getActualLineContentBefore(offset) {
      var actualLineContent = this._actual.getLineContent();

      return actualLineContent.substring(0, this.firstCharOffset + offset);
    }
  }, {
    key: "getTokenCount",
    value: function getTokenCount() {
      return this._lastTokenIndex - this._firstTokenIndex;
    }
  }, {
    key: "findTokenIndexAtOffset",
    value: function findTokenIndexAtOffset(offset) {
      return this._actual.findTokenIndexAtOffset(offset + this.firstCharOffset) - this._firstTokenIndex;
    }
  }, {
    key: "getStandardTokenType",
    value: function getStandardTokenType(tokenIndex) {
      return this._actual.getStandardTokenType(tokenIndex + this._firstTokenIndex);
    }
  }]);

  return ScopedLineTokens;
}();
export function ignoreBracketsInToken(standardTokenType) {
  return (standardTokenType & 7
  /* value */
  ) !== 0;
}